import Link from 'next/link';
import Image from 'next/image';
import { APP_URLS, EMAILS } from 'constants/index';
import { VisaIcon, MastercardIcon } from 'components/icons';
import { useTranslation } from 'next-i18next';
import { incrementReferrer } from 'services/user.service';
import { trackEvent } from 'services/userEvent.service';

import styles from './index.module.scss';

const Footer = () => {
  const { t } = useTranslation('footer');

  const handleInstagramClick = () => {
    void incrementReferrer('instagram');
    trackEvent('instagramClick');
  };

  const handleTiktokClick = () => {
    void incrementReferrer('tiktok');
    trackEvent('tiktokClick');
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.top}>

          {/* Brand */}
          <div className={styles.brand}>
            <Link href='/' className={styles.logoRow}>
              <div className={styles.logoWrap}>
                <Image src='/logo.png?v=3' alt='Logo' width={36} height={36} />
              </div>
              <Image src='/logo2.png' alt='Бібікалка' width={120} height={32} unoptimized />
            </Link>
            <p className={styles.desc}>{t('description')}</p>
            <a href={`mailto:${EMAILS.support}`} className={styles.email}>
              {EMAILS.support}
            </a>
            <div className={styles.socials}>
              <a
                href='https://www.instagram.com/bibikalka.com.ua/'
                target='_blank'
                rel='noopener noreferrer'
                className={styles.socialBtn}
                aria-label='Instagram'
                onClick={handleInstagramClick}
              >
                <svg width={18} height={18} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth={2} strokeLinecap='round' strokeLinejoin='round'>
                  <rect x='2' y='2' width='20' height='20' rx='5' ry='5' />
                  <circle cx='12' cy='12' r='4' />
                  <circle cx='17.5' cy='6.5' r='1' fill='currentColor' stroke='none' />
                </svg>
              </a>
              <a
                href='https://www.tiktok.com/@bibikalka'
                target='_blank'
                rel='noopener noreferrer'
                className={styles.socialBtn}
                aria-label='TikTok'
                onClick={handleTiktokClick}
              >
                <svg width={18} height={18} viewBox='0 0 24 24' fill='currentColor'>
                  <path d='M16.6 5.82c-.9-.98-1.4-2.26-1.4-3.57h-3.16v13.7c0 1.6-1.3 2.9-2.9 2.9a2.9 2.9 0 0 1 0-5.8c.28 0 .55.04.8.11V9.87a6.1 6.1 0 0 0-.8-.05A6.1 6.1 0 0 0 3 15.92 6.1 6.1 0 0 0 9.1 22a6.1 6.1 0 0 0 6.1-6.08V9.02a9.16 9.16 0 0 0 5.3 1.68V7.55c-1.31 0-2.53-.42-3.9-1.73Z' />
                </svg>
              </a>
            </div>
          </div>

          {/* Links */}
          <div className={styles.col}>
            <span className={styles.colTitle}>{t('terms.title')}</span>
            <nav className={styles.navList}>
              <Link className={styles.navLink} href={APP_URLS.ABOUT_US}>{t('terms.links.about')}</Link>
              <Link className={styles.navLink} href={APP_URLS.TERMS}>{t('terms.links.terms')}</Link>
              <Link className={styles.navLink} href={APP_URLS.PRIVACY}>{t('terms.links.policy')}</Link>
              <Link className={styles.navLink} href={APP_URLS.SHIPPING_AND_PAYMENT}>{t('terms.links.shipping')}</Link>
              <Link className={styles.navLink} href={APP_URLS.CONTACT_US}>{t('terms.links.contact')}</Link>
            </nav>
          </div>

          {/* Contacts + Payment */}
          <div className={styles.col}>
            <span className={styles.colTitle}>{t('contacts')}</span>
            <a href={`tel:${t('phone').replace(/\s/g, '')}`} className={styles.phone}>
              {t('phone')}
            </a>
            <p className={styles.workHoursTitle}>{t('workHoursTitle')}</p>
            <p className={styles.workHours}>{t('workHoursWeekday')}</p>
            <p className={styles.workHours}>{t('workHoursWeekend')}</p>

            <span className={styles.colTitle} style={{ marginTop: 28 }}>{t('paymentMethods')}</span>
            <div className={styles.payments}>
              <VisaIcon />
              <MastercardIcon />
            </div>
          </div>

        </div>
      </div>

      {/* Bottom bar */}
      {/*<div className={styles.bottom}>*/}
      {/*  <div className={styles.bottomInner}>*/}
      {/*    <span>© DigitalCodes 2023–2026</span>*/}
      {/*    <span className={styles.trademark}>{t('trademarksInfo')}</span>*/}
      {/*  </div>*/}
      {/*</div>*/}
    </footer>
  );
};

export default Footer;
